import { CoreIcon } from '../core-icon';
import chevronDownCircleFillSVG from '../../assets/icons/chevron-down-circle-fill.svg';
import type { IconProps } from '../core-icon';

export const ChevronDownCircleFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={chevronDownCircleFillSVG} {...props} />;
};
